import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getDashboardCount = () => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_DASHBOARD_COUNT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/dashboard/count`, config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_DASHBOARD_COUNT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_DASHBOARD_COUNT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_DASHBOARD_COUNT_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getDashboardGraph = (graphData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_DASHBOARD_GRAPH_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/dashboard/graph`,
        graphData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_DASHBOARD_GRAPH_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_DASHBOARD_GRAPH_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_DASHBOARD_GRAPH_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
